import React from 'react';
import { Translation, ProductItem } from '../types';

interface ProductsProps {
  t: Translation['products'];
}

export const Products: React.FC<ProductsProps> = ({ t }) => {
  return (
    <section id="products" className="py-20 bg-slate-900/50">
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t.title}</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{t.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {t.list.map((product) => (
            <div 
              key={product.id}
              className="group relative bg-slate-800 border border-slate-700 rounded-2xl p-6 hover:border-slate-500 transition-all hover:-translate-y-1 hover:shadow-xl"
            >
              {/* Discount Tag */}
              <div className="absolute top-4 right-4 bg-red-500/20 text-red-400 border border-red-500/30 px-2 py-1 rounded text-xs font-bold">
                -{product.discount}
              </div>

              {/* Icon/Logo Placeholder */}
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${product.color} flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg`}>
                {product.logoChar}
              </div>

              <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
              <p className="text-slate-400 text-sm mb-6 min-h-[40px]">{product.description}</p>

              <button className="w-full py-2 rounded-lg bg-slate-700 hover:bg-slate-600 text-white font-medium transition-colors border border-slate-600">
                Buy Now
              </button>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

